module.exports = new __parcel__URL__("holydeflection.afc766db.png").toString();